import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import TradeJournal from './pages/TradeJournal';
import About from './pages/About';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/journal" element={<TradeJournal />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <footer style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          textAlign: 'center',
          padding: '20px',
          marginTop: 'auto'
        }}>
          <p style={{ margin: 0, fontSize: '0.9rem' }}>
            © {new Date().getFullYear()} Keke Technology and Trade. All rights reserved.
          </p>
        </footer>
      </div>
    </Router>
  );
}

export default App;